import { FlashcardDeckBuilder } from "@/components/Flashcards/FlashcardDeckBuilder"
import { PageShell } from "@/components/Layout"
import { useRouteBreadcrumbs } from "@/navigation/route-meta"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/_layout/flashcards/$deckId/edit")({
  component: EditDeckPage,
})

function EditDeckPage() {
  const { deckId } = Route.useParams()
  const breadcrumbs = useRouteBreadcrumbs("flashcards.index", [
    { label: "Edit Deck" },
  ])

  return (
    <PageShell title="Edit Deck" breadcrumbs={breadcrumbs}>
      <FlashcardDeckBuilder mode="edit" deckId={deckId} />
    </PageShell>
  )
}
